module.exports = __webpack_public_path__ + "assets/img/partner_bg.27f2cafc.png";